module.exports = __webpack_public_path__ + "img/09.8f65ab88.jpg";